/**
 * @file profile-modal-ids.ts
 * @description
 * -----------------------------------------------------
 * Identificadores estables compartidos entre los modales del perfil y los
 * botones que los abren, para poder enlazarlos vía `aria-controls`.
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-22
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

export const PROFILE_EDIT_MODAL_ID = "profile-edit-modal";
export const PROFILE_CHANGE_PASSWORD_MODAL_ID = "profile-change-password-modal";
